import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
export const SUGGESTION_INSERT_MARKER_CLASS = 'suggestion-insert-marker';
export const suggestionInsertMarkersPluginKey = new PluginKey('suggestionInsertMarkers');
const buildInsertMarkerDecorations = (doc, markers) => {
    const decorations = [];
    markers.forEach((marker) => {
        if (marker.pos < 0 || marker.pos > doc.content.size) {
            return;
        }
        decorations.push(Decoration.widget(marker.pos, () => {
            const element = document.createElement('span');
            element.className = SUGGESTION_INSERT_MARKER_CLASS;
            element.setAttribute('data-suggestion-id', marker.id);
            if (marker.issueType) {
                element.setAttribute('data-issue-type', marker.issueType);
            }
            element.setAttribute('contenteditable', 'false');
            element.setAttribute('aria-hidden', 'true');
            return element;
        }, {
            side: -1,
            key: `suggestion-insert-${marker.id}`,
        }));
    });
    return DecorationSet.create(doc, decorations);
};
export const SuggestionInsertMarkers = Extension.create({
    name: 'suggestionInsertMarkers',
    addCommands() {
        return {
            setSuggestionInsertMarkers: (markers) => ({ tr, dispatch }) => {
                tr.setMeta(suggestionInsertMarkersPluginKey, { markers });
                if (dispatch) {
                    dispatch(tr);
                }
                return true;
            },
        };
    },
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: suggestionInsertMarkersPluginKey,
                state: {
                    init: () => DecorationSet.empty,
                    apply(tr, current) {
                        const meta = tr.getMeta(suggestionInsertMarkersPluginKey);
                        if (meta?.markers) {
                            return buildInsertMarkerDecorations(tr.doc, meta.markers);
                        }
                        if (tr.docChanged) {
                            return current.map(tr.mapping, tr.doc);
                        }
                        return current;
                    },
                },
                props: {
                    decorations(state) {
                        return suggestionInsertMarkersPluginKey.getState(state) ?? DecorationSet.empty;
                    },
                },
            }),
        ];
    },
});
//# sourceMappingURL=suggestion-insert-markers.js.map